/**
 * Shared WhatsApp interactive-message vocabulary that needs to be reachable
 * from both the real composer (Chat/MessageBar/InteractiveAction) and the
 * SmartLeadbot sandbox preview, without either pulling in the other's
 * dependency tree.
 *
 * `LOCKED_FOOTER_TEXT` is the footer shown to Pro/Basic plans (and the value
 * bff-web coerces custom footers to for those plans). Single source of truth
 * — keep in sync with bff-web's `defaultInteractiveFooter` constant (there's
 * a canary test that fails if they drift).
 */
export const LOCKED_FOOTER_TEXT = 'via leadsales';
